"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSiderSubMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const FSiderSubMenuItem = ({ children = undefined, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `f-sider-submenu-item` }, children)));
};
exports.FSiderSubMenuItem = FSiderSubMenuItem;
//# sourceMappingURL=FsiderSubMenuItem.js.map